import {
  Activity,
  Boxes,
  DatabaseBackup,
  LayoutDashboard,
  LogOut,
  MapPin,
  Menu,
  RadioTower,
  ScanLine,
  Settings,
  X
} from "lucide-react";
import { useState, type ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { Brand } from "./Brand";

const links = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard },
  { to: "/inventory", label: "Inventory", icon: Boxes },
  { to: "/provision", label: "Provision Tags", icon: RadioTower, admin: true },
  { to: "/batch", label: "Batch Location", icon: ScanLine },
  { to: "/locations", label: "Locations", icon: MapPin },
  { to: "/operations", label: "Exports & Backups", icon: DatabaseBackup, admin: true },
  { to: "/activity", label: "Activity Log", icon: Activity, admin: true },
  { to: "/settings", label: "Settings", icon: Settings }
];

export function AppShell({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  return (
    <div className="app-shell">
      <header className="topbar">
        <button className="icon-button mobile-only" onClick={() => setOpen(true)} aria-label="Open menu">
          <Menu size={22} />
        </button>
        <Brand />
        <div className="topbar-spacer" />
        <span className="server-health">
          <i /> Private server
        </span>
        <span className="user-name">{user?.display_name}</span>
      </header>
      {open && <button className="scrim" aria-label="Close menu" onClick={() => setOpen(false)} />}
      <aside className={`sidebar ${open ? "open" : ""}`}>
        <div className="sidebar-mobile-head">
          <Brand />
          <button className="icon-button" onClick={() => setOpen(false)} aria-label="Close menu">
            <X size={22} />
          </button>
        </div>
        <nav>
          {links
            .filter((link) => !link.admin || user?.role === "administrator")
            .map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <Icon size={20} strokeWidth={1.8} />
                {label}
              </NavLink>
            ))}
        </nav>
        <button className="nav-logout" onClick={logout}>
          <LogOut size={20} /> Sign out
        </button>
      </aside>
      <main className="main-content">{children}</main>
    </div>
  );
}
